import styles from './PartnerListSection.scss?inline';

import {BaseContainer} from "../../base/customComponent/BaseContainer";

class PartnerListSection extends BaseContainer {
    constructor() {
        super();
        this.customStyle = styles;
    }

    render() {
        const container = document.createElement('div');
        container.innerHTML = `
            <header></header>
            <div class="section-body">
                <div class="partner-list">
                    <slot></slot>
                </div>
            </div>
      `;
        // Clone Slots into container to prevent styling issues
        container.querySelector('header').append(this.createHeader('vertical-full'));
        return container;
    }

}

customElements.define('nxt-partner-list-section', PartnerListSection);
